import createEvent from './create-event';

// Consumed by the A/B testing (Convert) snippet in Views/Foundation/RandA/__ABTesting.cshtml
export const EVENT_APP_READY = 'app:ready';

export function notifyAppReady() {
    window.__appReady = true;
    document.dispatchEvent(createEvent(EVENT_APP_READY));
}
